var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Fullscreen-Arrow-Arrows-Direction-User Interface"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 45v14a2.006 2.006 0 0 1-2 2H45a3 3 0 0 1 0-6h5.76L36.25 40.49a3 3 0 0 1 4.24-4.24L55 50.76V45a3 3 0 0 1 6 0zM61 5v14a3 3 0 0 1-6 0v-5.76L40.49 27.75a3 3 0 1 1-4.24-4.24L50.76 9H45a3 3 0 0 1 0-6h14a2.006 2.006 0 0 1 2 2zM27.75 23.51a3 3 0 1 1-4.24 4.24L9 13.24V19a3 3 0 0 1-6 0V5a2.006 2.006 0 0 1 2-2h14a3 3 0 0 1 0 6h-5.76zM27.75 36.25a2.994 2.994 0 0 1 0 4.24L13.24 55H19a3 3 0 0 1 0 6H5a2.006 2.006 0 0 1-2-2V45a3 3 0 0 1 6 0v5.76l14.51-14.51a3 3 0 0 1 4.24 0z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full-screen.289f8a493ccd58bc6c289abb79fd61c7.svg";
export { ForwardRef as ReactComponent };